module.exports = __webpack_public_path__ + "static/media/03.9cbf9b9b.jpeg";